export const EMAIL_REGEX = /^[a-z0-9._%+\-]+@[a-z0-9][a-z0-9\-]*(?:\.[a-z0-9][a-z0-9\-]*)*\.[a-z]{2,}$/i;

const DANGEROUS_PATTERNS = [
  /<script\b[^>]*>[\s\S]*?<\/script>/i, // NOSONAR - S4784: risco de ReDoS aceitável, pois essa regex é executada apenas em HTML proveniente de API interna controlada, nunca de input direto do usuário
  /<style\b[^>]*>[\s\S]*?<\/style>/i,   // NOSONAR - S4784: mesmo contexto seguro da regex acima, HTML de origem interna e confiável
  /\bon\w+\s*=/i,
  /javascript\s*:/i,
  /vbscript\s*:/i,
  /data\s*:(?!image\/)/i,
  /<(iframe|object|embed|form|base|meta|link)\b/i,
  /expression\s*\(/i,
  /url\s*\(\s*['"]?\s*javascript/i, // NOSONAR - S4784: quantificadores simples sem aninhamento, sem risco real de ReDoS, usado apenas em validação de HTML de API interna
];

export function isSafeUrl(url: string): boolean {
  return typeof url === 'string' && url.startsWith('blob:');
}

export function isSafeHtml(value: string): boolean {
  if (!value || typeof value !== 'string') return false;
  return !DANGEROUS_PATTERNS.some(pattern => pattern.test(value));
}
